import { useEffect, useRef } from "react";

export function usePackagingStickyHeader(ready: boolean) {
  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    const header = ref.current;
    if (!ready || !header) return;
    const update = () => header.parentElement?.style.setProperty("--pack39-header-height", `${header.getBoundingClientRect().height}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(header);
    return () => observer.disconnect();
  }, [ready]);
  return ref;
}

export function usePackagingTableHeader(visible: boolean) {
  const ref = useRef<HTMLTableSectionElement>(null);
  useEffect(() => {
    const header = ref.current;
    const table = header?.closest("table");
    if (!visible || !header || !table) return;
    const update = () => table.style.setProperty("--pack39-table-header-height", `${header.getBoundingClientRect().height}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(header);
    return () => { observer.disconnect(); table.style.removeProperty("--pack39-table-header-height"); };
  }, [visible]);
  return ref;
}
